export interface SendNotificationMailRequest {
  userMailIds: number[]
  testMailAddress: string
  subject: string
  body: string
  sendFromBranchCode: string
}

export function SendNotificationMailRequestToJSON(
  value: SendNotificationMailRequest
): any {
  return {
    user_mail_ids:
      value.userMailIds.length !== 0 ? value.userMailIds : undefined,
    test_mail_address:
      value.testMailAddress !== '' ? value.testMailAddress : undefined,
    subject: value.subject !== '' ? value.subject : undefined,
    body: value.body !== '' ? value.body : undefined,
    send_from_branch_code:
      value.sendFromBranchCode !== '' ? value.sendFromBranchCode : undefined
  }
}
